import AuthService from "./axiosInstance";
import endpoints from "./endpoints";

const scoringTransparencyApi = {
  async listRuns() {
    const res = await AuthService.get(endpoints.SCORING_RUNS);
    return res.data;
  },

  async getTransparency(params = {}) {
    const res = await AuthService.get(endpoints.SCORING_TRANSPARENCY, { params });
    return res.data;
  },

  async getComponentDistribution(params = {}) {
    const res = await AuthService.get(endpoints.SCORING_TRANSPARENCY_DISTRIBUTION, { params });
    return res.data;
  },

  async getComponentDistributionMatrix(params = {}) {
    const res = await AuthService.get(endpoints.SCORING_TRANSPARENCY_DISTRIBUTION, {
      params: { ...params, matrix: true },
    });
    return res.data;
  },

  exportUrl(params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        query.set(key, value);
      }
    });
    return `${endpoints.SCORING_TRANSPARENCY_EXPORT}?${query.toString()}`;
  },

  async exportCsv(params = {}) {
    const res = await AuthService.get(endpoints.SCORING_TRANSPARENCY_EXPORT, {
      params,
      responseType: "blob",
    });
    const disposition = res.headers?.["content-disposition"] || "";
    const match = disposition.match(/filename="([^"]+)"/);
    return {
      blob: res.data,
      filename: match?.[1] || "scoring-transparency.csv",
    };
  },
};

export default scoringTransparencyApi;
